export default __webpack_public_path__ + "static/banner-media-release-sep24-ade589104e6ebfa2246eaa8f456f640c.jpg";